import { z } from 'zod';

export interface TypeApi {
  id: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
}

export const typeSchema = z.object({
  name: z.string().min(1, 'Debes ingresar un nombre de tipo'),
});

export type TypeSchema = z.infer<typeof typeSchema>;

export const defaultTypeValues: TypeSchema = {
  name: '',
}; 